import { useEffect, useState } from "react";
import { readScrapbook, scrapbookKey, toggleSaved } from "./model";

function initialSaved(): string[] {
  try { return readScrapbook(window.localStorage.getItem(scrapbookKey)); } catch { return []; }
}
export function useScrapbook() {
  const [ids, setIds] = useState(initialSaved);
  const [storageError, setStorageError] = useState(false);
  useEffect(() => {
    const update = (event: StorageEvent): void => {
      if (event.storageArea === window.localStorage && (event.key === scrapbookKey || event.key === null)) setIds(readScrapbook(event.newValue));
    };
    window.addEventListener("storage", update);
    return () => { window.removeEventListener("storage", update); };
  }, []);
  function toggle(id: string): void {
    let current = ids;
    if (!storageError) {
      try { current = readScrapbook(window.localStorage.getItem(scrapbookKey)); } catch { setStorageError(true); }
    }
    const next = toggleSaved(current, id);
    setIds(next);
    try { window.localStorage.setItem(scrapbookKey, JSON.stringify(next)); setStorageError(false); } catch { setStorageError(true); }
  }
  return { ids, toggle, storageError };
}
